// extracted by mini-css-extract-plugin
export default {"container":"UN-z","darkBackground":"VN-z","whiteBackground":"WN-z","headerButton":"XN-z","calloutHeading":"YN-z","calloutSubHeading":"ZN-z"};